const utils = {
    // 时间戳转日期格式
    formatDate(timestamp, lang) {
        if (lang == 'en') {
            const date = new Date(timestamp);
            return date.toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            });
        } else {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

    },
    // 判断图片是否是http格式
    hasHttp(str) {
        return str.includes("http");
    },
    getLanguageCode(a) {
        // 定义有效语言代码集合
        const validCodes = ['zh', 'en', 'ja', 'ko', 'fr', 'de', 'es', 'ru', 'pt', 'it', 'th'];

        // 判断输入字符串是否在有效集合中
        if (validCodes.includes(a)) {
            return a;
        } else {
            return 'en';
        }
    }
}

export default utils